<template>
  <div>
    <!-- Resultado de cada momento contable respectivamente -->
    <b-card no-body class="my-3">
      <b-tabs card>
        <b-tab v-for="res in importPoliza.result" :key="res.id" :title="res.content.poliza.momento">
          <polizas-r-h-card :item="res"></polizas-r-h-card>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PolizasRHCard from '@/components/Polizas/RH/PolizasRHCard'

export default {
  name: 'PolizasRHTabs',

  components: {
    PolizasRHCard
  },

  computed: {
    ...mapState('polizasRHModule', ['importPoliza'])
  }
}
</script>

<style lang="scss" scoped></style>
